import { observer } from 'mobx-react-lite';

import Icon from '@ui/components/Icon/Icon';
import IconButton from 'src/components/UI/IconButton/IconButton';

import './BackgroundTasksBoxHeader.scss';
import { Group, Loader } from '@mantine/core';
import Text from '@ui/components/Text/Text';

type BackgroundTasksBoxHeaderProps = {
	hasFinished: boolean,
	isMinimized: boolean,
	onMinimize: () => void,
	onClose: () => void
}

const BackgroundTasksBoxHeader = ( {
	hasFinished,
	isMinimized,
	onMinimize,
	onClose
}: BackgroundTasksBoxHeaderProps ) => (
	<Group className="BackgroundTasksBoxHeader" position="apart">
		<Group className="title" spacing="4px">
			{hasFinished ? (
				<Icon icon="check_circle" size={16} color="green.5" />
			) : (
				<Loader size="16px" />
			)}
			<Text variant="body-bold">{hasFinished ? 'Completed' : 'Processing Files'}</Text>
		</Group>
		<Group className="box-control" spacing="10px">
			<IconButton
				icon={isMinimized ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
				size="21px"
				color="black"
				onClick={onMinimize}
				testID="minimize-button"
			/>
			{hasFinished && (
				<IconButton
					icon="close"
					size="18px"
					color="black"
					onClick={onClose}
					testID="close-button"
				/>
			)}
		</Group>
	</Group>
);

export default observer( BackgroundTasksBoxHeader );
